var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXlsFile = function SvgXlsFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C5.175 0 4.5 0.675 4.5 1.5V22.5C4.5 23.325 5.175 24 6 24H21C21.825 24 22.5 23.325 22.5 22.5V6L16.5 0H6Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H22.5L16.5 0V4.5C16.5 5.325 17.175 6 18 6Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5L18 6H22.5V10.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C19.5 19.9125 19.1625 20.25 18.75 20.25H2.25C1.8375 20.25 1.5 19.9125 1.5 19.5V12C1.5 11.5875 1.8375 11.25 2.25 11.25H18.75C19.1625 11.25 19.5 11.5875 19.5 12V19.5Z",
    fill: "#84BD5A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76567 15.2902L7.80892 13.9829C8.12092 13.5749 8.72692 14.0962 8.38492 14.4862C8.02567 14.9122 7.64767 15.3742 7.28767 15.8474L8.51092 17.3707C8.84092 17.8207 8.18167 18.2519 7.85767 17.8079L6.75367 16.3927L5.66842 17.8387C5.36242 18.2759 4.68442 17.7847 5.02642 17.3767L6.23167 15.8474C5.85367 15.3734 5.48767 14.9122 5.12242 14.4862C4.74517 14.0362 5.44642 13.5749 5.72242 13.9957L6.76567 15.2902Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25116 14.2102C9.25116 14.0122 9.41916 13.8442 9.62916 13.8442C9.82116 13.8442 9.98316 14.013 9.98316 14.2102V17.2147H11.6144C12.2017 17.2147 12.2144 18 11.6144 18H9.62991C9.41991 18 9.25191 17.8507 9.25191 17.6347V14.2102H9.25116Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7515 14.7502C12.8895 13.5862 14.646 13.377 15.474 14.013C15.882 14.3422 15.45 14.8642 15.09 14.6002C14.646 14.319 13.6387 14.187 13.5127 14.8095C13.3507 15.7935 15.9592 15.2302 15.9172 16.8255C15.8752 18.3487 13.6687 18.384 12.8407 17.7007C12.642 17.5387 12.6487 17.2755 12.7567 17.1127C12.9127 16.9575 13.086 16.9035 13.2907 17.0715C13.782 17.4067 15.048 17.6587 15.1372 16.8067C15.06 15.9202 12.5655 16.4535 12.7515 14.7502Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 20.25H4.5V21H18.75C19.1625 21 19.5 20.6625 19.5 20.25V19.5C19.5 19.9125 19.1625 20.25 18.75 20.25Z",
    fill: "#CAD1D8"
  })));
};
export default SvgXlsFile;